module.exports = () => {

  // Sprawdź czy istnieje element DOM.
  let container = document.getElementById("angular-restore");
  try {
    if (container && /\S/.test(container.innerText)){
      return JSON.parse(container.innerText);
    }
  } catch(e){
    console.warn(e);
  }
};